import { render, staticRenderFns } from "./company-settings.vue?vue&type=template&id=d8d32272&scoped=true&"
import script from "./company-settings.vue?vue&type=script&lang=js&"
export * from "./company-settings.vue?vue&type=script&lang=js&"
import style0 from "./company-settings.vue?vue&type=style&index=0&id=d8d32272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d32272",
  null
  
)

export default component.exports